import { useState } from 'react';
import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import type { IApiSubmitResultBase } from '@/types/api';
import type { IPwlJugMissingModel } from '@/types/history/pwl-jug-missing';

const PWL_JUG_MISSING_ENDPOINT = '/api/register/pwl-jug-missing';

const defaultPwlJugMissingModel: IPwlJugMissingModel = {
    lastJugShippedRecently: false,
    totalJugsShipped: 0,
    languageData: {},
};

type TPwlJugMissingResult = IApiSubmitResultBase & { results?: Partial<IPwlJugMissingModel> };

export const usePwlJugMissing = (registrationId: number, editKey: string) => {
    const url = `${PWL_JUG_MISSING_ENDPOINT}/${registrationId}/${editKey}`;

    const { model: loaded, isLoading, error } = useApiModel(url, defaultPwlJugMissingModel);
    const [override, setOverride] = useState<IPwlJugMissingModel | null>(null);
    const model = override ?? loaded;

    const { submit: post, isSubmitting, submitError } = useApiSubmit<void, Partial<IPwlJugMissingModel>, TPwlJugMissingResult>(
        url,
        () => ({}),
        (results) => ({ results }),
    );

    const sendAnother = () =>
        post().then(({ results }) => {
            if (results) setOverride({ ...defaultPwlJugMissingModel, ...results });
        });

    return { model, isLoading, error, sendAnother, isSubmitting, submitError };
};
